<template>
<div class="app flex-row align-items-center">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card-group mb-0">
          <div class="card p-4">
            <div class="card-body">
              <form v-if="!resetSuccess" v-on:submit="validateBeforeSubmit($event,false)" action="#">
                <h3>Nova palavra-passe</h3>
                <p class="text-muted">Para completar o processo, preencha o formulário abaixo</p>
                <b-form-fieldset label="Palavra-passe">
                  <b-form-input type="email" name="email" v-model="item.email" placeholder="Email" v-validate="{ required: true, email:true }" :state="validateState('email')"></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('email') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
                <b-form-fieldset label="Palavra-passe">
                  <b-form-input type="password" name="password" v-model="item.password" placeholder="Palavra-passe" v-validate="{required:true, min: 8}" :state="validateState('password')" ref="password"  data-vv-validate-on="change"></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('password') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
                <b-form-fieldset label="Confirme a palavra-passe">
                  <b-form-input type="password" name="password_confirmation" v-model="item.password_confirmation" placeholder="Confirme a palavra-passe" v-validate="{confirmed: 'password', required:passwordRequired}" :state="validateState('password_confirmation')"  data-vv-validate-on="change"></b-form-input>
                  <b-form-invalid-feedback>
                    {{ errors.first('password_confirmation') }}
                  </b-form-invalid-feedback>
                </b-form-fieldset>
                <div class="row">
                  <div class="col-12 text-right">
                    <button :disabled="working" type="submit" class="btn btn-primary px-4">Alterar palavra-passe</button>
                  </div>

                </div>
              </form>
              <div v-if="resetSuccess">
                <h3>Nova palavra-passe</h3>
                <p>A sua palavra-passe foi alterada com sucesso.</p>
                <b-button variant="primary" :to="{name:'login'}" >Continuar</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'ResetPassword',
  data() {
    return {
      resetSuccess: false,
      working: false,
      item: {
        password: '',
        password_confirmation: '',
        token: '',
        email: ''
      }
    }
  },
  computed: {
    passwordRequired: function() {
      return this.item.password.length > 0 && !this.errors.has('password')
    }
  },
  methods: {
    validateBeforeSubmit(evt) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit()
          return
        }
        this.$toastr('error', 'Tem campos inválidos', 'Erro')
      })
    },
    submit() {
      var data = this.item
      this.axios.post('auth/reset', data).then(response => {
        this.resetSuccess = true
      }).catch(response => {
        this.$toastr('error', response.data.message, 'Erro')
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    }
  },
  created() {
    if (typeof this.$route.params.token === 'undefined' || !this.$route.params.token) {
      this.$router.push({name: 'login'})
    }
    this.item.token = this.$route.params.token
  }
}
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?389d7aba